import * as React from 'react';
import autobind from 'autobind-decorator';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// components
import Forum from 'Screens/Forum/Student/Forum';
import Navbar from 'Screens/Layout/Common/Components/Navbar';
import Concept from '../Components/Concept';

// interfaces
import { IConceptData } from 'store/StateInterfaces';

// actions
import {
    loadConceptDataRequest,
} from '../Actions/Actions';


export interface IConceptStudentPageProps {
    match: any;
    actions: any;
    data: IConceptData;
}

export interface IConceptStudentPageState {

}

class ConceptStudentPage extends React.Component<IConceptStudentPageProps, IConceptStudentPageState> {
    constructor(props: IConceptStudentPageProps) {
        super(props);
    }


    componentDidMount() {
        this.props.actions.loadConceptDataRequest(this.props.match.params.conceptId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.conceptId != this.props.match.params.conceptId)
            this.props.actions.loadConceptDataRequest(this.props.match.params.conceptId);
    }

    public render() {
        const { data } = this.props;
        if (!data) {
            return <div>Loading...</div>
        }
        const forum = data.tag ? <Forum id={data.tag} /> : null;
        return (
            <React.Fragment>
                <Navbar navbarClass='navbar-light' />
                <Concept
                    forum={forum}
                    data={data}
                />
            </React.Fragment>
        );
    }
}



interface IReduxState {
    studentConceptDataMap: Map<number, IConceptData>;
}

const mapStateToProps = (state: IReduxState, { match }) => {
    const conceptId = match.params.conceptId;
    let data = undefined;
    if (state.studentConceptDataMap.has(conceptId)) {
        data = state.studentConceptDataMap.get(conceptId)
    }

    return {
        match,
        data
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        loadConceptDataRequest,
    }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ConceptStudentPage);